import { Spinner } from '@paysera/ui';
export const PageLoader = () => (<div className="flex flex-wrap gap-2 justify-center page-loader" data-testid="loader">
        <Spinner />
    </div>);
